<template>
<div class="map-route-component">
  <van-popup v-model="showPopup"
            class="route-popup"
            :overlay="false"
            position="bottom">
    <div class="routes">
      <div class="route"
          v-for="(route, index) in routes"
          :key="route.id"
          @click="handleRouteDetail(index)">
        <div class="route-wrapper">
          <div class="route-left">
            <div class="route-name">{{ route.name }}</div>
            <div class="route-brief" v-if="route.points">{{ $t('home.routeInfo', { amount: route.points.length, time: route.time}) }}</div>
          </div>
          <div class="route-right">
            <div class="route-btn">{{ $t('home.routeDetail') }}</div>
          </div>
        </div>
        <div class="line" v-if="index < routes.length - 1"></div>
      </div>
    </div>
  </van-popup>
</div>
</template>

<script>
import { Popup } from 'vant'
import 'vant/lib/popup/style'

export default {
  data () {
    return {
      showPopup: false
    }
  },
  props: {
    routes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    'van-popup': Popup
  },
  methods: {
    displayPopup () {
      console.log('收到')
      this.showPopup = true
    },
    hidePopup () {
      this.showPopup = false
    },
    // 点击查看详情
    handleRouteDetail (index) {
      this.$emit('showDetail', index)
    }
  }
}
</script>

<style lang="scss">
.route-popup {
  border-radius: 8px 8px 0 0;
}
.routes {
  max-height: calc(95vh - 97px);
  overflow: auto;
  padding: 20px 12px;

  .line {
    margin: 10px 0;
    height: 1px;
    background-color: #f1f1f1;
  }

  .route {
    &-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0 8px 10px;
    }

    &-name {
      font-size: 15px;
      line-height: 21px;
      margin-bottom: 5px;
      font-weight: bold;
      font-family: GothamBold;
    }

    &-brief {
      font-size: 12px;
      color: #888888;
      margin-top: 5px;
    }

    &-btn {
      border: 1px solid #f8a909;
      width: 76px;
      height: 24px;
      border-radius: 14px;
      font-size: 12px;
      color: #f8a909;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
